import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ProcedimentosService } from 'src/app/services/procedimentos.service';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { RequestingPhysicianService } from 'src/app/services/requesting-physician.service';
import { ParametrosService } from 'src/app/services/parametros.service';

@Component({
  selector: 'app-procedimento-client',
  templateUrl: './procedimento-client.component.html',
  styleUrls: ['./procedimento-client.component.scss']
})
export class ProcedimentoClientComponent implements OnInit, OnChanges {
  myProcedimentoControl = new FormControl();
  @Input() procedimentoOptions: any;
  filteredProcedimentoOptions: Observable<any[]>;
  @Input() procedimentoSelecionado: any;

  myProfissionalControl = new FormControl();
  profissionalOptions: any = {};
  procedimentoProfissionais: any = [];
  filteredProfissionalOptions: Observable<any[]>;
  profissionalSelecionado: any;

  myRequestingPhysicianControl = new FormControl();
  @Input() requestingPhysiciansOptions: any = []
  @Input() selectedRequestingPhysicians: any

  idadeMinima: number | string = ''
  idadeMaxima: number | string = ''
  minDataNascimento: string = ''
  maxDataNascimento: string = ''
  minDataValidar: Date = new Date()
  maxDataValidar: Date = new Date()
  pedirDataNascimento: boolean = false;
  pedirAnexo: boolean = false;
  pedirAnexoObrigatorio: boolean = false;
  dataNascimento: string = '';
  ocultarSolicitante: boolean = false

  @Input() stepper: any;
  @Input() servicos: any;
  @Input() convenioSel: any;
  @Input() planoSel: any;
  @Input() especialidadeSel: any;
  smallScreen: boolean;
  profissionais: any;
  breakpoint: number;

  @Output() validarCamposProcedimento = new EventEmitter<boolean>();
  @Output() carregarHorarios = new EventEmitter<any>();
  @Output() updateServicos = new EventEmitter<any>();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private procedimentosService: ProcedimentosService,
    private parametrosService: ParametrosService
  ) {
    this.smallScreen = (window.innerWidth <= 400) ? true : false;
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe(result => {
        this.smallScreen = result.matches;
      });
      this.minDataValidar.setHours(12)
      this.maxDataValidar.setHours(12)
  }

  ngOnInit() {
    this.setFormControls()
    this.setupAutocomplete()

    const ocultarSolicitanteLoad: any = this.parametrosService.getParams('OCULTAR_SOLICITANTE') || { valor: 'false' }
    this.ocultarSolicitante = ocultarSolicitanteLoad.valor === 'true' ? true : false 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["requestingPhysiciansOptions"]) {
      this.requestingPhysiciansOptions = changes["requestingPhysiciansOptions"].currentValue
    }

    if (changes["procedimentoOptions"]) {
      this.procedimentoOptions = changes["procedimentoOptions"].currentValue
      this.setupAutocomplete()
    }
  } 

  setupAutocomplete() {
    this.filteredProcedimentoOptions = this.myProcedimentoControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterProcedimento(value))
    )
  }

  onOptionSelected(event: any) {
    const value = event.option.value
    const foundRequestingPhysician = this.requestingPhysiciansOptions.find((physician) => physician.PessoaNome === value)
    if (foundRequestingPhysician) this.selectedRequestingPhysicians = foundRequestingPhysician.ProfMedSolicitanteID
  }

  onResize(event: any) {
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 3;
  }

  setFormControls() {
    this.filteredProcedimentoOptions = this.myProcedimentoControl.valueChanges
      .pipe(
        startWith(''),
        map((value: any) => this._filterProcedimento(value))
      );
  }

  _filterProcedimento(value: string): any[] {
    const filterValue = value ? value.toLowerCase() : ''
    return this.procedimentoOptions.filter(option => option.descricao.toLowerCase().includes(filterValue))
  }

  onVoltarClick() {
    this.pedirDataNascimento = false
    this.pedirAnexo = false
    this.pedirAnexoObrigatorio = false
    this.myProcedimentoControl.reset()
    this.stepper.previous();
  }

  completeStepper() {
    if (this.myProcedimentoControl.status === 'VALID'
      && (
        (this.myProfissionalControl.status === 'VALID' && this.procedimentoProfissionais.length > 0)
        || (this.procedimentoProfissionais.length === 0)
      )) {
      this.validarCamposProcedimento.emit(true);
    } else {
      this.validarCamposProcedimento.emit(false);
    }
  }

  onProcedimentoBlur() {
    if (this.myProcedimentoControl.value) {
      this.myProcedimentoControl.setValue(this.myProcedimentoControl.value);
    }
    const { value } = this.myProcedimentoControl;

    if (value && value.descricao) {
      const option = this.procedimentoOptions.find(
        (item: any) => item.descricao.toLowerCase() === value.descricao.toLowerCase()
      );
      if (option) this.procedimentoSelecionado = option
    }

    if (!this.procedimentoSelecionado) {
      this.myProcedimentoControl.setErrors({ incorrect: true });
    }
    this.completeStepper();
  }

  displayFn(procedimento?: any): string | undefined {
    return procedimento && procedimento.descricao ? procedimento.descricao : undefined
  }

  selectedOn(event: MatAutocompleteSelectedEvent) {
    this.pedirDataNascimento = false
    this.pedirAnexo = false
    this.pedirAnexoObrigatorio = false

    const procedimento = event.option.value

    this.myProcedimentoControl.setValue(procedimento);
    this.procedimentoSelecionado = this.procedimentoOptions.find(proc => proc.descricao === procedimento);

    if (procedimento) {
      this.idadeMinima = procedimento.faixa_etaria_inicio
      this.idadeMaxima = procedimento.faixa_etaria_fim
      this.pedirDataNascimento = procedimento.faixa_etaria_inicio > 0 && procedimento.faixa_etaria_fim > 0 && localStorage.getItem('userData') !== ''
      this.maxDataValidar = new Date()
      this.minDataValidar = new Date()
      this.maxDataValidar.setHours(12)
      this.minDataValidar.setHours(12)
      this.maxDataValidar.setFullYear(this.maxDataValidar.getFullYear() - procedimento.faixa_etaria_fim)
      this.minDataValidar.setFullYear(this.minDataValidar.getFullYear() - (procedimento.faixa_etaria_inicio + 1))
      this.minDataValidar.setDate(this.minDataValidar.getDate() + 1)
      this.minDataNascimento = this.maxDataValidar.toISOString().split('T')[0]
      this.maxDataNascimento = this.minDataValidar.toISOString().split('T')[0]
     
      if (procedimento.anexo.toUpperCase() === 'NENHUM') {
        this.pedirAnexo = false
        this.pedirAnexoObrigatorio = false
      }
      if (procedimento.anexo.toUpperCase() === 'OPCIONAL') {
        this.pedirAnexo = true
        this.pedirAnexoObrigatorio = false
      }
      if (procedimento.anexo.toUpperCase() === 'EXIGIR') {
        this.pedirAnexo = true
        this.pedirAnexoObrigatorio = true
      }
    }
  }

  onChangeDataNascimento(event: any) {
    this.dataNascimento = ''
    const newdate = new Date(event.target.value)
    if (+newdate >= +new Date(this.minDataNascimento) && +newdate <= +new Date(this.maxDataNascimento))
      this.dataNascimento = event.target.value

  }

  onChangeAnexoInput(event: any) {
    this.procedimentosService.procedimentoAnexos = event.target.files
  }

  validaProcedimento() {
    this.updateServicos.emit(this.servicos);
    if (this.myProcedimentoControl.status === 'VALID') {
      if (this.pedirAnexoObrigatorio && this.procedimentosService.procedimentoAnexos.length) {
        this.validarCamposProcedimento.emit(true);
        this.carregarHorarios.emit();
        this.stepper.next();
      } else {
        if (!this.pedirAnexoObrigatorio) {
          this.validarCamposProcedimento.emit(true);
          this.carregarHorarios.emit();
          this.stepper.next();
        }
      }
    } else {
      this.validarCamposProcedimento.emit(false);
      this.myProcedimentoControl.markAsTouched({ onlySelf: true });
    }
  }

  isFormValid() {
    let valido = true;

    if (this.myProcedimentoControl.status !== 'VALID') {
      valido = false;
    }
    if (!this.procedimentosService.procedimentoAnexos.length && this.pedirAnexo && this.pedirAnexoObrigatorio) {
      valido = false
    }

    if (!this.dataNascimento && this.pedirDataNascimento) {
      valido = false
    }

    if (this.dataNascimento && this.pedirDataNascimento) {
      if (+new Date(this.dataNascimento) < +new Date(this.minDataNascimento))
        valido = false
      if (+new Date(this.dataNascimento) > +new Date(this.maxDataNascimento))
        valido = false
    }

    return valido;
  }
}
